// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BroadcasterPauseState__wrapper__29qOF","title":"BroadcasterPauseState__title__Qia_-","text":"BroadcasterPauseState__text__2E4cL"};